import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import classNames from 'classnames';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import moment from 'moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT, APP_COLORS } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import checkPermission from '../Common/permissions';

import { ROOT_URL } from '../../actions/root_url';
import { getFromToDates } from '../Common/cleanDates';

// import {buttonStyle} from '../Common/style'
const BackgroundColorFormatter = React.createClass({
  render() {
    if (this.props.value <= 0) {
      console.log(this.props.value);
      return (<div style={{ backgroundColor: '#2196F3' }}>{this.props.value}</div>);
    } else if (this.props.value < 1) return <div style={{ backgroundColor: '#F44336' }}>{this.props.value}</div>;
    else if (this.props.value < 3) return <div style={{ backgroundColor: '#FFC107' }}>{this.props.value}</div>;
    else if (this.props.value > 7) return <div style={{ backgroundColor: '#4CAF50' }}>{this.props.value}</div>;
    else if (this.props.value == 'Check') return <div style={{ backgroundColor: '#1976D2' }}>{this.props.value}</div>;
    return <div className="react-grid-Cell">{this.props.value}</div>;
  },
});

const LeftWeeksFormatter = React.createClass({
  render() {
    if (this.props.value < 0) return <div style={{ backgroundColor: '#F44336' }}>{this.props.value}</div>;
    return <div>{this.props.value}</div>;
  },
});
class PurchaseReferenceReport extends Component {
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,

      purchaseReference: {
        allrows: [],
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        columns: [{}],
      },
      currentGroup: null,
      currentCategory: null,
      clear: true,
      groupExpanded: false,
      currentButton: null,
      referencePdfFrameLoaded: true,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultOfForm('typeRadios', 'week', 'purchaseReferenceReport');
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.props.fetchGroups();
    // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.purchaseReferenceReport && nextProps.purchaseReferenceReport != this.props.purchaseReferenceReport) {
      const product_lines = [...nextProps.purchaseReferenceReport.Product_Lines];
      const date1 = nextProps.purchaseReferenceReport.Date1;
      const date2 = nextProps.purchaseReferenceReport.Date2;
      const date3 = nextProps.purchaseReferenceReport.Date3;
      let column;
      product_lines.map((line) => {
        line.LeftWeeks = line.AverageSale ? ((line.Inventory__InStock - line.AverageSale) / line.AverageSale).toFixed(2) : 0;
      });
      if (this.props.typeRadios == 'week') {
        column = [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'RefNum',
            name: <Translate value="ref_num" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'Name',
            name: <Translate value="product_name" />,
            resizable: true,
            sortable: true,
            width: 250,
            filterable: true,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 150,
            filterable: true,
          },
          {
            key: 'FourWeeksSale',
            name: <Translate value="4_wks_sale" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'Inventory__InStock',
            name: <Translate value="in_stock" />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'WeeklySale',
            name: <Translate value="wk_sale" />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'StockLeftAfterOneWeek',
            name: <Translate value="stock_left_after_1_week" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
            formatter: LeftWeeksFormatter,
          },
          {
            key: 'WeeksLeftAfterOneWeek',
            name: <Translate value="weeks_left_after_1_week" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
            formatter: LeftWeeksFormatter,
          },
          {
            key: 'Inventory__Purchased',
            name: <Translate value="purchased" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
        ];
      } else {
        column = [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'RefNum',
            name: <Translate value="ref_num" />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'Name',
            name: <Translate value="product_name" />,
            resizable: true,
            sortable: true,
            width: 200,
            filterable: true,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 130,
            filterable: true,
          },
          {
            key: 'ThreeDaysSale',
            // name: <Translate value="daily_sale" />,
            name: '3 Days Sale',
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'Inventory__InStock',
            name: <Translate value="in_stock" />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'DailySale',
            name: <Translate value="daily_sale" />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'Day1',
            name: <Translate value={date1} />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'Day2',
            name: <Translate value={date2} />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'Day3',
            name: <Translate value={date3} />,
            resizable: true,
            sortable: true,
            width: 60,
            filterable: true,
          },
          {
            key: 'StockLeftAfterOneDay',
            // name: <Translate value="week_left" />,
            name: 'Stock Left After 1 Day',
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
            formatter: LeftWeeksFormatter,
          },
          {
            key: 'DaysLeftAfterOneDay',
            // name: <Translate value="week_left" />,
            name: 'Days Left After 1 Day',
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
            formatter: LeftWeeksFormatter,
          },
          {
            key: 'Inventory__Purchased',
            name: <Translate value="purchased" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
        ];
      }
      const purchaseReference = {
        ...this.state.purchaseReference, rows: product_lines, allrows: product_lines, columns: column,
      };
      this.setState({ purchaseReference });
    }

    if (nextProps.typeRadios && nextProps.typeRadios != this.props.typeRadios) {
      let group = this.state.currentGroup;
      let category = this.state.currentCategory;

      if (group == -1 && category == -1) {
        group = null;
        category = null;
      } else if (category == -1) {
        category = null;
      } else if (category) {
        group = null;
      }
      this.props.fetchPurchasingReference('show', nextProps.typeRadios, group, category);
    }

    if (nextProps.groups && nextProps.groups != this.props.groups) {
      const productGroup_id = nextProps.groups[0].ProductGroup_id;
      this.setState({ currentGroup: productGroup_id });
      this.props.fetchPurchasingReference('show', this.props.typeRadios, productGroup_id, null);
    }

    if (nextProps.purchaseReferencePdf && nextProps.purchaseReferencePdf !== this.props.purchaseReferencePdf) {
      this.setState({ referencePdfFrameLoaded: false });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const productGroup_id = this.state.currentGroup;
    const productCategory_id = this.state.currentCategory;
    const groups = document.getElementsByName('group');
    let i = 0;
    for (; i < groups.length; i++) {
      if (groups[i].id != `g${productGroup_id}`) {
        groups[i].style.backgroundColor = null;
      } else {
        groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }
    const categories = document.getElementsByName('category');
    i = 0;
    if (categories) {
      for (; i < categories.length; i++) {
        if (categories[i].id != `c${productCategory_id}`) {
          categories[i].style.backgroundColor = null;
        } else {
          categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.referencePdfFrameLoaded !== this.state.referencePdfFrameLoaded && this.state.referencePdfFrameLoaded === false) {
      return false;
    }
    return true;
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage });
  }

  handlePrintFrameOnLoad = () => {
    this.setState({ referencePdfFrameLoaded: true });
  }


  fetchPurchasingReference() {
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    if (group == -1 && category == -1) {
      group = null;
      category = null;
    } else if (category == -1) {
      category = null;
    } else if (category) {
      group = null;
    }
    this.props.fetchPurchasingReference('show', this.props.typeRadios, group, category);
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

  renderTable() {
    if (this.props.purchaseReferenceReportIsLoading && !this.props.purchaseReferenceReportError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.purchaseReferenceReportError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchaseReferenceReportError)}</div>
        </ContentWrapper>
      );
    }


    // Parameters of the react-data-grid

    const tableHeight = (window.innerHeight < 930) ? 645 : 645;

    const getRows = () =>
      // console.log(this.state)
      Data.Selectors.getRows(this.state.purchaseReference);


    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const purchaseReference = Object.assign({}, this.state.purchaseReference, { sortColumn, sortDirection });
      this.setState({ purchaseReference });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.purchaseReference.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const purchaseReference = { ...this.state.purchaseReference, filters: newFilters };

      this.setState({ purchaseReference });
    };


    const onClearFilters = () => {
      // all filters removed
      const purchaseReference = { ...this.state.purchaseReference, filters: {}, rows: this.props.purchaseReferenceReport.purchaseReference };
      this.setState({ purchaseReference });
    };

    // Custom Formatter component
    // const BackgroundColorFormatter = React.createClass({
    //       render() {
    //             if (this.props.value <= 0) {
    //                console.log(this.props.value)
    //                return (<div style={{backgroundColor:"#2196F3"}}>{this.props.value}</div>)
    //              }
    //             else if (this.props.value < 1) return <div style={{backgroundColor:"#F44336"}}>{this.props.value}</div>;
    //             else if (this.props.value < 3 ) return <div style={{backgroundColor:"#FFC107"}}>{this.props.value}</div>;
    //             else if (this.props.value > 7 ) return <div style={{backgroundColor:"#4CAF50"}}>{this.props.value}</div>;
    //             else if (this.props.value == 'Check' ) return <div style={{backgroundColor:"#1976D2"}}>{this.props.value}</div>;
    //             else return <div className="react-grid-Cell">{this.props.value}</div>;
    //           }
    //     });

    // Column difinition

    return (
    // React Table Inventory List
      <Row>
        <Col xs={12}>
          <div className="react-table-purchasing-reference" id="purchaseReference-dataGrid1">
            <ReactDataGrid
              enableCellSelect
              rowHeight={25}
              headerRowHeight={65}
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={this.state.purchaseReference.columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={tableHeight}
            />
          </div>
        </Col>
      </Row>
    );
  }

  handleClickButton(value) {
    let currentButton = this.state.currentButton;
    const allrows = [...this.state.purchaseReference.allrows];
    let rows = [];
    if (currentButton && currentButton == value) {
      rows = allrows;
    } else {
      rows = allrows.filter(r => r.StockLevel == value);
      currentButton = value;
    }
    const purchaseReference = { ...this.state.purchaseReference, rows };
    this.setState({ purchaseReference, currentButton });
  }

  handleClickCategory(id) {
    this.props.fetchPurchasingReference('show', this.props.typeRadios, null, id);
    this.setState({ currentCategory: id });
  }

  renderCategories(group_id) {
    if (!this.props.groupCategories) {
      return;
    }
    const groupCategories = this.props.groupCategories;
    let description;
    if (localStorage.getItem('lang') == 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') == 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup == group_id && this.state.groupExpanded) {
      return groupCategories.map(category => (
        <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={`c${category.ProductCategory_id}`} onClick={this.handleClickCategory.bind(this, category.ProductCategory_id)}>
          <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{` ${category[description]}`}
        </li>
      ));
    }
  }

  handleClickGroup(group, id) {
    const groupExpanded = this.state.groupExpanded;
    if (group && this.state.currentGroup == group.ProductGroup_id) {
      this.setState({ groupExpanded: !groupExpanded });
      if (!groupExpanded) {
        this.setState({ currentCategory: -1 });
        this.props.fetchPurchasingReference('show', this.props.typeRadios, this.state.currentGroup, null);
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
    } else if (group) {
      this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1 });
      this.props.fetchPurchasingReference('show', this.props.typeRadios, group.ProductGroup_id, null);
      this.props.fetchGroupCategories(group.ProductGroup_id);
    } else {
      this.setState({ currentGroup: -1, currentCategory: -1 });
      this.props.fetchPurchasingReference('show', this.props.typeRadios, null, null);
    }
  }


  renderGroups() {
    if (!this.props.groups) return;
    const groups = this.props.groups;
    return groups.map((group) => {
      let GroupNum = parseInt(group.GroupNum);
      if (GroupNum < 10) GroupNum = `0${GroupNum}`;
      let description;
      if (localStorage.getItem('lang') == 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') == 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div className="category-nav-item" name="group" id={`g${group.ProductGroup_id}`} onClick={this.handleClickGroup.bind(this, group, `g${group.ProductGroup_id}`)}>
            <label>{GroupNum}</label> {` ${group[description]}`}
          </div>
          {this.renderCategories(group.ProductGroup_id)}
        </Panel>
      );
    });
  }

  renderPrintIframe() {
    const { referencePdfFrameLoaded } = this.state;
    const { purchaseReferencePdf } = this.props;
    return (
      <PrintIframe
        id="referencePDF"
        loaded={referencePdfFrameLoaded}
        name="referencePDF"
        onLoad={this.handlePrintFrameOnLoad}
        pdf={purchaseReferencePdf}
        title={<Translate value="print_purchase_reference" />}
      />
    );
  }

  render() {
    const typeradio = this.props.typeRadios;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    const height = (this.state.tableHeight + 70).toString();
    const tableCollapseFix = { height };
    if (group == -1 && category == -1) {
      group = null;
      category = null;
    } else if (category == -1) {
      category = null;
    } else if (category) {
      group = null;
    }
    const { toDate: endTime } = getFromToDates(moment());
    // if (group) {
    //   group = `ProductGroup_id=${group}`;
    // } else {
    //   group = '';
    // }
    // if (category) {
    //   category = `ProductCategory1_id=${category}`;
    // } else {
    //   category = '';
    // }
    // const print_url = `${ROOT_URL}v1/purchase/referenceguide/print/${
    //   typeradio}/?${group}${category
    // }&Bearer=${localStorage.getItem('token')}`;
    const excel_url = `${ROOT_URL}v1/purchase/referenceguide/excel/${
      typeradio}/?${group ? `ProductGroup_id=${group}` : ''}${category ? `ProductCategory1_id=${category}` : ''
    }&end_time=${endTime}&Bearer=${localStorage.getItem('token')}`;
    return (
    //---------------
    // Begin HTML
    //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="purchase_reference" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <ButtonToolbar>
          <SpinnerButton
            bsStyle="primary"
            disabled={this.props.requestingPurchaseReferencePdf || !checkPermission('print_purchase_reference')}
            icon="fa-print"
            translation={<Translate value="print" />}
            loading={this.props.requestingPurchaseReferencePdf}
            onClick={() => {
              this.props.printPurchaseReference({ typeradio, group, category, endTime });
            }}
          />
          <Button
            bsStyle="success"
            href={excel_url}
            disabled={!checkPermission('print_purchase_reference')}
          >
            <em className="fa fa-download" /><Translate value="excel" />
          </Button>
        </ButtonToolbar>

        <Grid id="purchase-reference-page">
          {/* <h1><Translate value="purchase_reference_report" /></h1> */}
          <Row>
            {/* Product Category Nav */}
            <Col xs={2}>
              <Panel id="category-nav" className="panelStyle">
                <Panel className="panelStyle" >
                  <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="group" id="g-1" onClick={this.handleClickGroup.bind(this, null, '-1')}>
                    <Translate value="all" />
                  </div>
                </Panel>
                {this.renderGroups()}
              </Panel>
            </Col> {/* End Product Category Nav */}

            {/* Main Workspace */}
            <Col xs={10}>

              {/* Inventory Table */}
              <Row>
                <Col xs={12}>
                  <Panel className="position-relative table-collapse-fix mb0">
                    <div className="table-filters">
                      <Field name="typeRadios" component={renderTypeRadios} />
                    </div>
                    {/* <ButtonToolbar className="table-buttons">
                                <Button bsStyle="info" onClick = {this.handleClickButton.bind(this, "dead")} >
                                  <Translate value="dead" />
                                </Button>
                                  <Button bsStyle="primary" onClick = {this.handleClickButton.bind(this, "outofstock")} >
                                    <Translate value="out_of_stock" />
                                  </Button>
                                  <Button bsStyle="success" onClick = {this.handleClickButton.bind(this, "overstock")} >
                                    <Translate value="over_stock" />
                                  </Button>
                                  <Button bsStyle="warning"  onClick = {this.handleClickButton.bind(this, "lowstock")}>
                                    <Translate value="low_stock" />
                                  </Button>
                                  <Button bsStyle="danger" onClick = {this.handleClickButton.bind(this, "warning")} >
                                    <Translate value="warning" />
                                  </Button>
                              </ButtonToolbar> */}
                    {/* Render Inventory Table  */}
                    {this.renderTable() }
                  </Panel>
                </Col>
              </Row>
            </Col> {/* End Main Workspace */}
            {/* End Row Wrapper  */}
          </Row>
        </Grid>
        { this.renderPrintIframe() }
      </ContentWrapper>
    //---------------
    // End HTML
    //---------------

    );
  }
}

let renderTypeRadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-4');
  return (
    <div className="form-group">
      <label className={titleClass}>
        <input
          {...props.input}
          type="radio"
          value="week"
          checked={props.input.value === 'week'}
        />
        <span style={{ 'font-size': '20px' }} ><Translate value="by_week" /></span>
      </label>
      <label className={titleClass}>
        <input
          {...props.input}
          type="radio"
          value="day"
          checked={props.input.value === 'day'}
        />
        <span style={{ 'font-size': '20px' }} ><Translate value="by_3_days" /></span>
      </label>
    </div>
  );
};


export default PurchaseReferenceReport;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseReference.jsx